exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".has-search .form-control {\n  padding-left: 2.375rem; }\n\n.has-search .form-control-feedback {\n  position: absolute;\n  z-index: 2;\n  display: block;\n  width: 2.375rem;\n  height: 2.375rem;\n  line-height: 2.375rem;\n  text-align: center;\n  pointer-events: none;\n  color: #aaa; }\n\ninput[type=\"search\"] {\n  -webkit-appearance: searchfield; }\n\ninput[type=\"search\"]::-webkit-search-cancel-button {\n  -webkit-appearance: searchfield-cancel-button; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/order-worksheet/boms/boms.component.scss
// module id = ../../../../../src/app/order-worksheet/boms/boms.component.scss
// module chunks = main